import {
  TCFDISyncCategory,
  TControlledErrorCodes,
  TDateFormat,
  TCFDISyncStatus,
  TServerSentOperations,
} from 'models/shared.models'
import CheckGreen from 'assets/check-green.svg'
import InfoWarning from 'assets/info-warning.svg'
import Update from 'assets/update.svg'
import {
  STORE_EVENT_TYPES,
  CONTROLLED_ERROR_CODES,
  SERVER_SENT_OPERATIONS,
  CFDI_SYNC_STATUS,
  CFDI_SYNC_CATEGORIES,
} from 'lib/enums/shared.enums'
import { TStoreEvents } from 'store/StoreEvent/storeEvent.models'

export const months: Record<string, number> = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
}

export const sseErrorCodeToastMessagesMapp: Readonly<
  Partial<Record<TControlledErrorCodes, string>>
> = {
  [CONTROLLED_ERROR_CODES.NET_002]:
    'El servicio está temporalmente indisponible, por favor intenta de nuevo.',
  [CONTROLLED_ERROR_CODES.DB_003]:
    'Necesita sincronizar antes de poder descargar opiniones de cumplimiento.',
} as const

export const operationIdGlobalEventTypeMap: Readonly<
  Partial<Record<TServerSentOperations, TStoreEvents>>
> = {
  [SERVER_SENT_OPERATIONS.COMPLIANCE]:
    STORE_EVENT_TYPES.FETCH_MANAGEMENT_WORKSPACES,
} as const

export const dateConfigOptionsMap: Readonly<
  Record<TDateFormat, Intl.DateTimeFormatOptions>
> = {
  short: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'America/Mexico_City',
  },
  full: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'America/Mexico_City',
  },
  monthYear: {
    year: 'numeric',
    month: 'long',
    timeZone: 'America/Mexico_City',
  },
} as const

export const CFDISyncProcessStatusIconsMap: Readonly<
  Record<TCFDISyncStatus, { src: string; alt: string }>
> = {
  [CFDI_SYNC_STATUS.COMPLETED]: { src: CheckGreen, alt: 'completado' },
  [CFDI_SYNC_STATUS.FAILED]: { src: InfoWarning, alt: 'error' },
  [CFDI_SYNC_STATUS.ONGOING]: { src: Update, alt: 'en proceso' },
} as const

export const CFDISyncCategoriesLabelMap: Record<TCFDISyncCategory, string> = {
  [CFDI_SYNC_CATEGORIES.INGRESOS]: 'I',
  [CFDI_SYNC_CATEGORIES.EGRESOS]: 'E',
} as const
